import {connect} from 'react-redux';
import BasicComment from './BasicComment';
import Action from '../../redux/Actions';
import CommentModel from '../../types/CommentModel';
import Constants from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import UserModel from '../../types/UserModel';
import {RouteComponentProps, withRouter} from 'react-router';
import Themeable from '../../types/Themeable';
import IVideoPlayer from '../../types/IVideoPlayer';
import ReviewModel from '../../types/ReviewModel';
import ReviewVersionModel from '../../types/ReviewVersionModel';

const mapStateToProps = (state: ReduxState, ownProps: IBasicCommentOwnProps): IBasicCommentOwnProps & IBasicCommentStoreMappedProps => {
   return {
      history: ownProps.history,
      location: ownProps.location,
      match: ownProps.match,
      player: state.player || null,
      currentUser: state.currentUser || {} as UserModel,
      isEditing: (state.editingComment && state.editingComment.id === ownProps.comment.id) || false,
      themeName: state.themeName || Constants.themeName.default,
      reviewId: state.reviewId,
      isOwner: state.isOwner,
      review: state.currentReview,
      reviewVersion: state.currentReviewVersion,
      comment: ownProps.comment,
      alternateDisplayText: ownProps.alternateDisplayText,
      isEditable: ownProps.isEditable,
      deleteAnnotationOnSave: ownProps.deleteAnnotationOnSave,
      onCancelEdit: ownProps.onCancelEdit,
      onEditClick: ownProps.onEditClick,
      onReplyClick: ownProps.onReplyClick,
      onSaveEdit: ownProps.onSaveEdit,
      onSelect: ownProps.onSelect
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<BasicCommentProps> => {
   return {
      onEditing: (editingCommentId = null) => {
         dispatch(Action.setEditingComment(editingCommentId));
      },
      setSelectedComment: id => {
         dispatch(Action.setSelectedComment(id));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasicComment));

interface IBasicCommentOwnProps extends RouteComponentProps {
   comment: CommentModel;
   alternateDisplayText: string;
   isEditable: boolean;
   deleteAnnotationOnSave: boolean;
   onCancelEdit(): void;
   onSaveEdit(): void;
   onReplyClick(): void;
   onSelect(): void;
   onEditClick(): void;
}

interface IBasicCommentStoreMappedProps extends Themeable {
   currentUser: UserModel;
   player: IVideoPlayer;
   isEditing: boolean;
   reviewId: string;
   isOwner: boolean;
   review: ReviewModel;
   reviewVersion: ReviewVersionModel;
}

interface IBasicCommentStoreDispatchProps {
   onEditing(commentId?: string): void;
   setSelectedComment(id: string): void;
}

export type BasicCommentContainerProps = IBasicCommentOwnProps;
export type BasicCommentProps = IBasicCommentOwnProps & IBasicCommentStoreMappedProps & IBasicCommentStoreDispatchProps;
